import { Injectable } from '@angular/core';
import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from '../../authentication.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  httpUrl: any
  constructor(private auth: AuthenticationService, private http: HttpClient) {
    this.httpUrl = this.auth.httpUrl;
  }



  async getDepartment(obj: any) {
    const resp = await this.http.get<any>(this.httpUrl + '/sdp/admin/department/getDepartment' + obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async addDepartment(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/admin/department/addDepartment', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async deleteDepartment(obj: any) {
    const res = await this.http.delete<any>(this.httpUrl + '/sdp/admin/department/deleteDepartment' + obj).toPromise().then(res => {
      return res;
    });
    return res;
  }


  async updateDepartment(obj: any) {
    const resp = await this.http.post<any>(this.httpUrl + '/sdp/admin/department/updateDepartment', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

}